import React from 'react';
import { Quote } from 'lucide-react';

import './Endorsements.css';
import { theme } from '../../theme/designSystem';
import { endorsementsData } from '../../data/endorsementsData';

function Endorsements() {
    return (
        <section className="endorsements section-pad" id="endorsements" style={{ backgroundColor: theme.tertiary }}>
            <div className="container">
                <div className="endorsements--header">
                    <span className="eyebrow">Endorsements</span>
                    <h2 style={{ color: theme.primary }}>What leaders who worked with me say</h2>
                    <p style={{ color: theme.textSecondary }}>
                        Assessments from a Qualcomm engineering leader, a company president, and a founding CEO,
                        drawn from their recommendation letters.
                    </p>
                </div>

                <div className="endorsements--grid">
                    {endorsementsData.map((item, index) => (
                        <figure
                            key={item.id}
                            className="endorsement--card fade-in-up"
                            style={{ backgroundColor: theme.cardBg, borderColor: theme.border, animationDelay: `${index * 0.1}s` }}
                        >
                            <Quote className="endorsement--quote-icon" size={26} aria-hidden="true" />
                            <blockquote className="endorsement--quote" style={{ color: theme.textPrimary }}>
                                {item.quote}
                            </blockquote>
                            <figcaption className="endorsement--author">
                                <span className="endorsement--avatar" aria-hidden="true">{item.initials}</span>
                                <span className="endorsement--meta">
                                    <span className="endorsement--name" style={{ color: theme.primary }}>{item.name}</span>
                                    <span className="endorsement--role" style={{ color: theme.textSecondary }}>
                                        {item.title}, {item.org}
                                    </span>
                                </span>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Endorsements;
